import { render } from "./StationItem.vue?vue&type=template&id=c8f70f8a"
import script from "./StationItem.vue?vue&type=script&lang=js"
export * from "./StationItem.vue?vue&type=script&lang=js"

import "./StationItem.vue?vue&type=style&index=0&id=c8f70f8a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__